import { useState } from "react";
import DispatchPoint from "../../models/dispatch-point";
import { CCard, CCardBody, CCardHeader, CCollapse } from "@coreui/react";

import DispatchPointCrudActions from "./DispatchPointCrudActions";

interface DispatchPointCardProps {
  dispatchPoint: DispatchPoint;
  onUpdateClick: (inv: DispatchPoint) => void;
  onDeleteClick: (inv: DispatchPoint) => void;
  isDemo?: boolean;
}

export function DispatchPointCard({
  dispatchPoint,
  onUpdateClick,
  onDeleteClick,
  isDemo,
}: DispatchPointCardProps) {
  const [open, setOpen] = useState(true);

  let identifier = "";

  if (dispatchPoint["establishment.code"]) {
    identifier = identifier + dispatchPoint["establishment.code"];
  }

  if (identifier) {
    identifier = identifier + `-${dispatchPoint.identifier}`;
  } else {
    identifier = identifier + dispatchPoint.identifier;
  }
  return (
    <CCard className="mb-2">
      <CCardHeader
        className="d-flex justify-content-between align-items-center cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <span>
          <strong>{identifier}</strong>
        </span>
        <span className="d-flex align-items-center gap-2">
          <strong>{""}</strong>
          <span
            className="rounded-circle bg-white d-flex justify-content-center align-items-center ml-1 border border-dark"
            style={{ width: "22px", height: "22px" }}
          >
            <i
              className={`fa fa-chevron-${open ? "up" : "down"}`}
              style={{ color: "black", fontSize: "12px" }}
            />
          </span>
        </span>
      </CCardHeader>
      <CCollapse show={open}>
        <CCardBody>
          <p>
            <strong>Establecimiento:</strong>{" "}
            {dispatchPoint["establishment.code"]}
          </p>
          <p>
            <strong>Código punto de expedición:</strong>{" "}
            {dispatchPoint.identifier}
          </p>

          <div>
            <strong>Acciones disponibles:</strong>{" "}
            <DispatchPointCrudActions
              dispatchPoint={dispatchPoint}
              onUpdateClick={onUpdateClick}
              onDeleteClick={onDeleteClick}
              isDemo={isDemo}
            />
          </div>
        </CCardBody>
      </CCollapse>
    </CCard>
  );
}
